import React,{useEffect,useState} from 'react'
import styled from '@emotion/styled'
import {getCustomerCart} from '../../network';

import {connect} from 'react-redux';
import {formatCurrency, formatPrice} from '../../helpers/Helper'
import { Link } from 'react-router-dom';
import {isLoggedInCustomer} from '../../utils/auth';
import ConfirmationComponent from '../shared/ConfirmationComponent';
const MenuWrapper = styled.div`
    display:flex;
    flex-direction:column;
    height: auto;
    justify-content:space-between;
    align-items: center;
    /* margin-left:2.5rem; */
    .footer{
        width: 20.44rem;
        height: 4.5rem;
        margin-left:3rem;
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-14);
        line-height: var(--space-18);
        /* or 129% */

        text-align: center;
        justify-self:center;
        /* default/neutral-gray/700 */

        color: #5C5C5C;
    }
    .hyperlink{
        cursor:pointer;
        margin-left:1rem;
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: var(--font-18);
        line-height: var(--space-20);
        /* identical to box height, or 100% */
        justify-self:center;
        text-align: center;
        text-decoration-line: underline;

        /* Company Dark */

        color: #049CBE;
    }
`;
const CartContainer = styled.div`
    display:flex;
    flex-direction:column;
`;
const ItemContainer = styled.div`
    display:flex;
    flex-direction:column;
    width:100%;
    justify-content:space-between;
`;
const ImageContainer = styled.div`
    width: 5.5rem;
    height: 5.5rem;

    /* default/shade/white */

    background: #FFFFFF;
    /* default/gray/300 */

    border: 0.666667px solid #D3D9DE;
    box-sizing: border-box;
    border-radius: 10.6667px;

    img{
        width:90%;
        height:90%;
        object-fit:contain;
    }
`;
const Container = styled.div`
    display:flex;
    flex-direction:row;
    width: auto;
    justify-content:space-between;
`;
const TextContainer = styled.div`
    display:flex;
    flex-direction:column;
    height:7rem;
    padding-left: var(--space-16);
    justify-content:space-between;

    h1{
        width:20rem;
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: var(--font-20);
        line-height: var(--space-28);
        /* or 140% */


        /* default/neutral-gray/900 */

        color: var(--color-gray-600);
    }
    .brand{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: var(--font-20);
        line-height: var(--space-28);
        /* or 140% */


        /* default/neutral-gray/900 */

        color: #232323;
    }
    span{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-16);
        line-height: var(--space-18);
        /* identical to box height, or 100% */

        /* default/gray/800 */

        color: #353B40;
    }
    .quantity{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: var(--font-16);
        line-height: var(--space-18);
        
        /* default/gray/800 */
        
        color: #353B40;
    }
`;
const PriceContainer = styled.p`
    margin-top:5rem;
    margin-bottom:1rem;
    display:flex;
    flex-direction:row;
    width:15rem;
    justify-content:space-between;
    font-family: Inter,sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: var(--font-16);
    line-height: var(--space-18);

    color: #000000;

    .price{
        white-space:nowrap;
        margin-left:10rem;
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: var(--font-20);
        line-height: var(--space-24);

        color: #353B40;
    }
    .discount{
        white-space:nowrap;
        margin-left:1rem;
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: var(--font-16);
        line-height: var(--space-18);
        
        display: flex;
        align-items: center;
        text-align: right;
        text-decoration-line: line-through;
        
        
        color: #969696;
    }
`;
const Divider = styled.div`
    width: 25.5rem;
    height: 0px;

    border: 1px solid #B3BDC6;
`;
const TotalContainer = styled.div`
    margin-top:1rem;
    display:flex;
    flex-direction:row;
    width:25rem;
    justify-content:space-between;
    .subTotal{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-16);
        line-height: var(--space-18);

        color: #000000;
    }
    .total{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: var(--font-20);
        line-height: var(--font-24);

        text-align: right;

        /* default/blue/600 */

        color: #3182CE;
    }
`;
const ButtonContainer = styled.button`
    display:flex;
    flex-direction:row;
    padding: var(--space-16) 10.34rem;
    width: 25.5rem;
    height: var(--space-48);

    /* default/gray/700 */
    white-space:nowrap;
    background: #525B64;
    border-radius: 6px;
    font-family: Inter,sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: var(--font-16);
    line-height: var(--space-20);
    color:var(--color-white);
`;
const Head = styled.div`
    margin-top: 0rem;
    display:flex;
    flex-direction:row;
    width: 100%;
    justify-content:space-between;
    align-items: center;

    h1{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: var(--font-20);
        line-height: var(--space-24); 
        white-space: nowrap;
    }
    button{
        position: relative;
        /* bottom: 2rem; */
        width:3rem;
        height:3rem;
        box-sizing:border-box;
        background-color:var(--color-white);
        border-radius: var(--space-24);
        border:1px solid var(--color-gray-700);
        align-items:center;
    }
    img{
        width:2rem;
    }

    @media (max-width: 500px){
        button{
            width: 2rem;
            height: 2rem;
        }
       
    }
`;
const SideMenuComponent = ({auth,item,quantity,show,display,attr,price}) => {
    const [confirm,setConfirm] = useState('none');
    const [cart, setCart] = useState([]);
    const [summary, setSummary] = useState({
        originalPrice: 0,
        saleDeduction: 0,
        subTotal: 0,
        estTax: 0,
        orderTotal: 0
    });
    



    const retrieveCustomerCart = () => {
        if (isLoggedInCustomer(auth)){
        getCustomerCart(auth.customer_id, auth.token)
            .then(result => {
                setSummary({
                    originalPrice: result.totalOriginalPrice,
                    saleDeduction: result.totalSaleDeduction,
                    subTotal: result.totalSubTotal,
                    estTax: result.totalTax,
                    orderTotal: result.cartTotal,
                });
                setCart([...result.variants]);
            })
            .catch(error => console.error(error));
        }
    };

    useEffect(() => retrieveCustomerCart(), [Date.now()]);

    return (
        <>
        
        {item.product ?
                <MenuWrapper>
                    <Head><h1>Added To Cart</h1><button onClick={()=>{show();}}><img src="/icons/close_dark.svg" alt="close button"/></button></Head>
                    <CartContainer>
                        <ItemContainer>
                            <Container>
                                <ImageContainer>
                                    <img src={item.image} alt="product image"/>
                                </ImageContainer>
                                <TextContainer>
                                    <h1><span className="brand">{item.product.brand.name}</span> {item.product.name}</h1>
                                    <span>{attr}</span>
                                    <span className="quantity">{`Qty: ${quantity}`}</span>
                                </TextContainer>
                            </Container>
                            <PriceContainer>
                                Price <span className="price">{price.price}</span><span className="discount">{price.discount}</span>
                            </PriceContainer>
                            <Divider/>
                            <TotalContainer>
                                <p className="subTotal">{`Cart Subtotal (${cart.reduce((acc, val) => acc + val.quantity, 0)} items)`}</p>
                                <p className="total">{formatCurrency(summary.subTotal)}</p>
                            </TotalContainer>
                        </ItemContainer>
                    
                    </CartContainer>
                    
                <div style={{display:"flex",flexDirection:"column",height:"15rem",justifyContent:"space-between"}}>
                        <Link to={"/cart"}><ButtonContainer>View Cart</ButtonContainer></Link>
                        <ConfirmationComponent className="confirm" confirm={confirm} setConfirm={setConfirm}/>
                        <ButtonContainer style={{backgroundColor:"var(--color-orange-500)"}} onClick={()=>setConfirm("flex")}>Place Order</ButtonContainer>
                        <p className="footer">Lorem ipsum dolor sit amet, consectetur adip iscing elit. Dignissim magna lorem ornare orac. At sed parturient rhoncus massa, commodo. Mattis eleifend mollis quam nulla.</p>
                        <p className="hyperlink" onClick={()=>show()}> Return To Products</p>
                    </div>
                </MenuWrapper>
        :
        null}
        </>
    )
}
const mapStateToProps = (state,props) => ({
    auth: state.auth,
    item:props.item,
    quantity:props.quantity,
    show:props.show,
    display:props.confirm,
    attr:props.attribute,
    price:props.price
});



export default connect(mapStateToProps)(SideMenuComponent);
